import React from 'react';
import { Button } from 'react-bootstrap';
import InventorySearchItem from '../../inventory/InventorySearchItem';

const SiteMapPickerSlotPanel = ({ slot, selecting, onSelectUnit, onInventoryUpdate }) => {
  if (slot?.isOfficeBuilding) {
    return (
      <div className="pt-2 border-top">
        <h6 className="smallFont py-2 text-muted">This is an Office Building</h6>
      </div>
    );
  }

  if (!slot?.inventory) {
    return (
      <div className="pt-2 border-top">
        <div className="d-flex flex-column align-items-center my-4" style={{ width: 'min(300px, 85vw)' }}>
          <h6 className="smallFont text-muted">No unit at this slot.</h6>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-2 border-top">
      <h6 className="smallFont">Unit at this slot</h6>
      <div className="my-2 mx-3">
        <InventorySearchItem
          mini
          inventory={slot.inventory}
          slotNumber={slot.number}
          siteId={slot.siteId}
          showLocationDetails
          selected
          fromMap
          coverImageEnabled
          onInventoryUpdate={onInventoryUpdate}
        />
      </div>
      <div className="border-top d-flex justify-content-end mt-1 pt-2">
        <Button
          type="button"
          size="sm"
          variant="success"
          disabled={selecting}
          onMouseDown={e => e.stopPropagation()}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onSelectUnit();
          }}
        >
          <h6 className="smallFont mb-0">Select Unit</h6>
        </Button>
      </div>
    </div>
  );
};

export default SiteMapPickerSlotPanel;
